import { render, staticRenderFns } from "./AboutVisit.vue?vue&type=template&id=64eed0aa&scoped=true&"
import script from "./AboutVisit.vue?vue&type=script&lang=js&"
export * from "./AboutVisit.vue?vue&type=script&lang=js&"
import style0 from "./AboutVisit.vue?vue&type=style&index=0&id=64eed0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eed0aa",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
